import PropTypes from 'prop-types';
import React from 'react';
import Panel from '@prisjakt/ui-panel';
import PanelHeader from '@prisjakt/ui-panel-header';

import CampaignLink from '../link';
import * as S from './styles';

const CampaignGroup = ({ campaigns, title, className }) => (
  <S.CampaignGroup className={className}>
    <Panel
      layoutMode="grid"
      header={title ? <PanelHeader title={title} /> : null}
    >
      {campaigns.map(campaign => (
        <S.CampaignListItem key={campaign.id}>
          <h4>{campaign.title.short}</h4>
          <p>{campaign.description.short}</p>
          <CampaignLink campaign={campaign} />
        </S.CampaignListItem>
      ))}
    </Panel>
  </S.CampaignGroup>
);

const { arrayOf, number, shape, string } = PropTypes;

CampaignGroup.propTypes = {
  title: string,
  campaigns: arrayOf(
    shape({
      id: number.isRequired,
      slug: string,
      title: shape({
        short: string,
        long: string,
      }),
      description: shape({
        short: string,
        long: string,
      }),
    }).isRequired
  ).isRequired,
  className: string,
};

CampaignGroup.defaultProps = {
  title: undefined,
  className: undefined,
};

export default CampaignGroup;
